import Axios from "axios";
import ApiUtils from "../utils/api_utils";

const API_URL = `https://${ApiUtils.authority}`;
const NewsSM = {
  state: {
    categories: [],
    dataNews: [],
    listBookmark: [],
  },
  reducers: {
    setNewsState(state, payload) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: (dispatch) => ({
    async getCategories(page = 1, rootState) {
      let result;
      await Axios.get(`${API_URL}/feeds/api/categories/?page=${page}`, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then((response) => {
          dispatch.NewsSM.setNewsState({
            ...rootState.NewsSM,
            categories: response.data.results,
          });
          result = {
            data: response.data.results,
            status: 200,
            message: "success",
          };
        })
        .catch((error) => {
          result = {
            data: [],
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
    async getListNewsByCategory(cat, rootState) {
      let result;
      await Axios.get(`${API_URL}/feeds/api/list/?category=${cat}&type=news`, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then((response) => {
          dispatch.NewsSM.setNewsState({
            ...rootState.NewsSM,
            dataNews: response.data.results,
          });
          result = {
            data: response.data.results,
            status: 200,
            message: "success",
          };
        })
        .catch((error) => {
          dispatch.NewsSM.setNewsState({
            // ...rootState.NewsSM,
            dataNews: [],
          });
          result = {
            data: [],
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
    async getMyBookmark(cat, rootState) {
      let result;
      await Axios.get(`${API_URL}/feeds/api/favorites/`, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then((response) => {
          dispatch.NewsSM.setNewsState({
            ...rootState.NewsSM,
            listBookmark: response.data.results,
          });
          result = {
            data: response.data.results,
            status: 200,
            message: "success",
          };
        })
        .catch((error) => {
          result = {
            data: [],
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
  }),
};

export default NewsSM;
